const agenda = document.querySelector('.agenda');

if (agenda) {
    const prev = agenda.previousElementSibling;

    if (prev) {
        prev.classList.add('spacing-100')
    }
}

